<template>
  <div class="form-wrapper">
    <h4>Edit Legacy User Report Preference</h4>
    <form @submit="handleSubmit">
      <label for="user-id">Legacy User Email</label>
      <input
        id="user-id"
        v-model.trim="userEmail"
        autofocus
        placeholder="Enter email"
        required
        type="email"
        class="border-2 p-3"
        @blur="fetchuserPreferences"
      />
      <label for="report-name">Report Name</label>
      <input
        id="report-name"
        v-model="reportTitle"
        autofocus
        placeholder="Enter report title ( for browser title )"
        required
        type="text"
        class="border-2"
      />
      <label for="report">Report Path</label>
      <input
        id="report"
        v-model="userReportPath"
        autofocus
        placeholder="Enter report path"
        required
        type="text"
        class="border-2"
      />
      <button
        class="p-3 shadow-md px-12 rounded-full mt-6 border-none text-white font-bold bg-green"
        style="outline: none"
      >
        Update User Report Path
      </button>
    </form>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      userEmail: "",
      userReportPath: undefined,
      userPreferences: undefined,
      reportTitle: undefined,
    }
  },
  watch: {
    userEmail(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.userReportPath = ""
        this.reportTitle = ""
      }
    },
  },
  methods: {
    fetchuserPreferences() {
      if (!this.userEmail.length) {
        return
      }
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/user_preferences?user_id=${this.userEmail}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const { collegeAdmin } = res.data.preferences
        if (collegeAdmin) {
          this.userReportPath = collegeAdmin.reportPath
          this.reportTitle = collegeAdmin.reportTitle
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault()

      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/user_preferences?user_id=${this.userEmail}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.userPreferences = res.data.preferences
          if (!this.userPreferences) {
            this.userPreferences = {}
          }
          this.userPreferences.collegeAdmin = {
            reportPath: this.userReportPath,
            reportTitle: this.reportTitle,
          }
          this.updatePreferences()
        })
        .catch(err => {
          this.$noty.error(`Failed to fetch and update user! ${err}`, {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
    updatePreferences() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/user_preferences`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: {
          user_id: this.userEmail,
          preferences: this.userPreferences,
        },
      })
        .then(() => {
          this.$noty.success("Successfully updated user!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(() => {
          this.$noty.error("Failed update user!", {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input,
select {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  /* text-align: center; */
}
textarea {
  width: 100%;
  height: 150px;
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
button {
  display: block;
  margin: 10px auto;
  text-align: center;
}
</style>
